import { useEffect, useState, useRef, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../utils/LanguageContext';
import videoCarr from '../assets/videocarr.mp4';
import imgPresta from '../assets/presta.jpeg';
import imgDistri from '../assets/distri.jpeg';
import imgRachat from '../assets/rachat.jpg';
import imgImport from '../assets/import.png';
import openspaceImg from '../assets/openspace.jpg';
import gtcImg from '../assets/Tchine.png';
import clientLogo1 from '../assets/logo1.jpeg';
import clientLogo2 from '../assets/logo2.jpg';
import clientLogo3 from '../assets/logo3.png';
import clientLogo4 from '../assets/logo4.jpg';
import clientLogo5 from '../assets/logo5.jpg';
import clientLogo6 from '../assets/logo6.png';
import './Home.css';

const PROCESS_ICONS = [
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="6"/><line x1="20" y1="20" x2="15.5" y2="15.5"/><path d="M8 11a3 3 0 0 1 3-3"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 5v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>,
];

const WHY_ICONS = [
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
];

const EXPERTISE_IMGS = [imgPresta, imgDistri, imgRachat, imgImport];

// Icons are static; values/labels are fetched from the API (editable by admin)
const TOP_ICONS = [
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
];

const BOT_ICONS = [
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/><polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/></svg>,
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
];

const DEFAULT_CHIFFRES_TOP_VALS = [
  { value: 5000, suffix: '+' },
  { value: 2,    suffix: '' },
  { value: 100,  suffix: '%' },
];

const STATIC_LOGOS = [clientLogo1, clientLogo2, clientLogo3, clientLogo4, clientLogo5, clientLogo6];


function useCountUp(target, duration, active) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let rafId;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.floor(eased * target));
      if (p < 1) { rafId = requestAnimationFrame(tick); }
    };
    rafId = requestAnimationFrame(tick);
    return () => { if (rafId) cancelAnimationFrame(rafId); };
  }, [target, duration, active]);
  return count;
}

function StatItem({ value, suffix, label }) {
  const [active, setActive] = useState(false);
  const ref = useRef(null);
  const count = useCountUp(value, 2000, active);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setActive(true); obs.disconnect(); } },
      { threshold: 0.5 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return (
    <div ref={ref} className="vs-stat">
      <span className="vs-stat__n">{count.toLocaleString('fr-FR')}{suffix}</span>
      <span className="vs-stat__l">{label}</span>
    </div>
  );
}

function Fade({ children, className = '', delay = 0 }) {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return (
    <div
      ref={ref}
      className={`vfade ${visible ? 'vfade--on' : ''} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
}

function ChiffreCount({ value, suffix }) {
  // This component only mounts after API data is ready, so we can start
  // the animation immediately — no IntersectionObserver needed.
  const count = useCountUp(value, 2200, true);
  return <span className="vchiffres__num">{count.toLocaleString('fr-FR')}{suffix}</span>;
}

function Home() {
  const location = useLocation();
  const { t } = useLanguage();
  const [sent, setSent] = useState(false);
  const [chiffresTop, setChiffresTop] = useState(null);
  const [chiffresBot, setChiffresBot] = useState(null);
  const [dynamicLogos, setDynamicLogos] = useState([]);

  const DEFAULT_CHIFFRES_TOP = useMemo(() => [
    { value: 5000, suffix: '+', label: t('home.chiffres.label1') },
    { value: 2,    suffix: '',  label: t('home.chiffres.label2') },
    { value: 100,  suffix: '%', label: t('home.chiffres.label3') },
  ], [t]);

  const DEFAULT_CHIFFRES_BOT = useMemo(() => [
    { label: t('home.chiffres.bot1') },
    { label: t('home.chiffres.bot2') },
    { label: t('home.chiffres.bot3') },
  ], [t]);

  const PROCESS = useMemo(() => [
    { num: '01', title: t('home.process.01.title'), desc: t('home.process.01.desc'), icon: PROCESS_ICONS[0] },
    { num: '02', title: t('home.process.02.title'), desc: t('home.process.02.desc'), icon: PROCESS_ICONS[1] },
    { num: '03', title: t('home.process.03.title'), desc: t('home.process.03.desc'), icon: PROCESS_ICONS[2] },
    { num: '04', title: t('home.process.04.title'), desc: t('home.process.04.desc'), icon: PROCESS_ICONS[3] },
    { num: '05', title: t('home.process.05.title'), desc: t('home.process.05.desc'), icon: PROCESS_ICONS[4] },
  ], [t]);

  const EXPERTISE = useMemo(() => [
    {
      title: t('home.expertise.1.title'), img: EXPERTISE_IMGS[0],
      desc: t('home.expertise.1.desc'),
      subdomains: [t('home.expertise.1.sub1'), t('home.expertise.1.sub2'), t('home.expertise.1.sub3'), t('home.expertise.1.sub4'), t('home.expertise.1.sub5')],
    },
    {
      title: t('home.expertise.2.title'), img: EXPERTISE_IMGS[1],
      desc: t('home.expertise.2.desc'),
      subdomains: [t('home.expertise.2.sub1'), t('home.expertise.2.sub2'), t('home.expertise.2.sub3'), t('home.expertise.2.sub4'), t('home.expertise.2.sub5')],
    },
    {
      title: t('home.expertise.3.title'), img: EXPERTISE_IMGS[2],
      desc: t('home.expertise.3.desc'),
      subdomains: [t('home.expertise.3.sub1'), t('home.expertise.3.sub2'), t('home.expertise.3.sub3'), t('home.expertise.3.sub4')],
    },
    {
      title: t('home.expertise.4.title'), img: EXPERTISE_IMGS[3],
      desc: t('home.expertise.4.desc'),
      subdomains: [t('home.expertise.4.sub1'), t('home.expertise.4.sub2'), t('home.expertise.4.sub3'), t('home.expertise.4.sub4'), t('home.expertise.4.sub5')],
    },
  ], [t]);

  const WHY = useMemo(() => [
    { title: t('home.why.1.title'), desc: t('home.why.1.desc'), icon: WHY_ICONS[0] },
    { title: t('home.why.2.title'), desc: t('home.why.2.desc'), icon: WHY_ICONS[1] },
    { title: t('home.why.3.title'), desc: t('home.why.3.desc'), icon: WHY_ICONS[2] },
    { title: t('home.why.4.title'), desc: t('home.why.4.desc'), icon: WHY_ICONS[3] },
  ], [t]);

  useEffect(() => {
    fetch('http://localhost:5001/api/content/chiffres')
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d?.chiffresTop?.length) {
          setChiffresTop(d.chiffresTop.map((item, i) => ({
            ...item,
            label: item.label || DEFAULT_CHIFFRES_TOP[i]?.label,
          })));
        } else {
          setChiffresTop(DEFAULT_CHIFFRES_TOP);
        }
        if (d?.chiffresBot?.length) {
          setChiffresBot(d.chiffresBot);
        } else {
          setChiffresBot(DEFAULT_CHIFFRES_BOT);
        }
      })
      .catch(() => {
        setChiffresTop(DEFAULT_CHIFFRES_TOP);
        setChiffresBot(DEFAULT_CHIFFRES_BOT);
      });
    fetch('http://localhost:5001/api/content/logos')
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (Array.isArray(d) && d.length) setDynamicLogos(d); })
      .catch(() => {});
  }, [DEFAULT_CHIFFRES_TOP, DEFAULT_CHIFFRES_BOT]);

  useEffect(() => {
    const id = location.state?.scrollTo;
    if (!id) return;
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 80);
    return () => clearTimeout(t);
  }, [location]);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="vitrine">

      {/* ── HERO ── */}
      <section className="vh" aria-label="Présentation Global Sourcing Solution Group">
        <video className="vh__video" autoPlay muted loop playsInline>
          <source src={videoCarr} type="video/mp4" />
        </video>
        <div className="vh__overlay" />
        <div className="vh__content">
          <p className="vh__tag" translate="no">GLOBAL SOURCING SOLUTION GROUP</p>
          <h1 className="vh__h1">
            {t('home.hero.tag')} <em>{t('home.hero.em')}</em>
          </h1>
          <div className="vh__sub">
            <p>{t('home.hero.sub1')}</p>
            <p>{t('home.hero.sub2')}</p>
            <p>{t('home.hero.sub3')}</p>
            <p>{t('home.hero.sub4')}</p>
            <p className="vh__sub--mobile">{t('home.hero.sub1')} {t('home.hero.sub2')}</p>
          </div>
          <div className="vh__actions">
            <button className="vbtn vbtn--gold vbtn--notch" onClick={() => scrollTo('contact-section')}>
              {t('home.hero.cta')}
            </button>
          </div>
        </div>
        <button className="vh__down" onClick={() => scrollTo('stats-section')} aria-label="Défiler vers le bas">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="26" height="26">
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>
      </section>

{/* ── PROCESS ── */}
      {/* ── CLIENTS ── */}
      <section className="vclients">
        <div className="vin">
          <Fade className="vhead">
            <p className="vhead__eye">{t('home.clients.eye')}</p>
            <h2 className="vhead__h2">{t('home.clients.h2a')}<strong>{t('home.clients.h2b')}</strong></h2>
          </Fade>
        </div>
        <div className="vclients__track-wrap">
          <div className="vclients__track">
            {(dynamicLogos.length > 0
              ? [...dynamicLogos, ...dynamicLogos]
              : [...STATIC_LOGOS, ...STATIC_LOGOS]
            ).map((item, i) => {
              const src = dynamicLogos.length > 0 ? item.data : item;
              const alt = dynamicLogos.length > 0 ? item.name : `Client ${(i % STATIC_LOGOS.length) + 1}`;
              return (
                <div key={i} className="vclients__logo">
                  <img src={src} alt={alt} loading="lazy" />
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="vprocess" id="services-section">
        <div className="vin">
          <Fade className="vhead">
            <p className="vhead__eye">{t('home.process.eye')}</p>
            <h2 className="vhead__h2">{t('home.process.h2')}</h2>
            <p className="vhead__sub">{t('home.process.sub')}</p>
          </Fade>
          <div className="vprocess__steps">
            {PROCESS.map((step, i) => (
              <Fade key={step.num} delay={i * 80}>
                <article className="vprocess__step">
                  <div className="vprocess__icon">{step.icon}</div>
                  <h3 className="vprocess__title">{step.title}</h3>
                  <p className="vprocess__desc">{step.desc}</p>
                </article>
              </Fade>
            ))}
          </div>
        </div>
      </section>

      {/* ── CHIFFRES ── */}
      <section className="vchiffres" style={{ backgroundImage: `url(${openspaceImg})` }}>
        <div className="vchiffres__overlay" />
        <div className="vchiffres__inner">
          <Fade className="vchiffres__title">
            <h2>{t('home.chiffres.title')}</h2>
          </Fade>
          <div className="vchiffres__grid">
            {(chiffresTop || []).map((item, i) => (
              <Fade key={i} delay={i * 100} className="vchiffres__item">
                <div className="vchiffres__circle">{TOP_ICONS[i % TOP_ICONS.length]}</div>
                <ChiffreCount value={item.value} suffix={item.suffix} />
                <span className="vchiffres__label">{item.label}</span>
              </Fade>
            ))}
            {(chiffresBot || []).map((item, i) => (
              <Fade key={i} delay={((chiffresTop || []).length + i) * 100} className="vchiffres__item">
                <div className="vchiffres__circle">{BOT_ICONS[i % BOT_ICONS.length]}</div>
                <span className="vchiffres__label">{item.label}</span>
              </Fade>
            ))}
          </div>
        </div>
      </section>

      {/* ── EXPERTISE ── */}
      <section className="vexpertise" id="expertise-section">
        <div className="vin">
          <Fade className="vhead">
            <p className="vhead__eye">{t('home.expertise.eye')}</p>
            <h2 className="vhead__h2">{t('home.expertise.h2')}</h2>
          </Fade>
          <div className="vexpertise__grid">
            {EXPERTISE.map((item, i) => (
              <Fade key={item.title} delay={i * 100}>
                <article className="vexpertise__card">
                  <div className="vexpertise__body">
                    <div className="vexpertise__title-row">
                      <svg className="vexpertise__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="9 12 11 14 15 10"/></svg>
                      <h3>{item.title.toUpperCase()}</h3>
                    </div>
                    <p className="vexpertise__desc">{item.desc}</p>
                    <ul className="vexpertise__sublist">
                      {item.subdomains.map((sub) => (
                        <li key={sub}>
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>
                          {sub}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="vexpertise__visual">
                    <img src={item.img} alt={item.title} loading="lazy" />
                    <button className="vexpertise__arrow" onClick={() => scrollTo('contact-section')} aria-label={t('home.hero.cta')}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                    </button>
                  </div>
                </article>
              </Fade>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY ── */}
      <section className="vwhy">
        <div className="vin">
          <Fade className="vhead">
            <p className="vhead__eye">{t('home.why.eye')}</p>
            <h2 className="vhead__h2">{t('home.why.h2')}</h2>
          </Fade>
          <div className="vwhy__grid">
            {WHY.map((item, i) => (
              <Fade key={item.title} delay={i * 80}>
                <article className="vwhy__card">
                  <div className="vwhy__icon">{item.icon}</div>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </article>
              </Fade>
            ))}
          </div>
        </div>
      </section>

      {/* ── ABOUT ── */}
      <section className="vabout" id="about-section">
        <div className="vabout__card">
          <Fade className="vabout__text">
            <p className="vabout__eye">{t('home.about.eye')}</p>
            <h2 className="vabout__h2">{t('home.about.h2')}</h2>
            <p>
              <span translate="no">Global Sourcing Solution Group</span> {t('home.about.p1')}
            </p>
            <p>{t('home.about.p2')}</p>
            <button className="vbtn vbtn--gold vbtn--notch" onClick={() => scrollTo('contact-section')}>
              {t('home.about.cta')}
            </button>
          </Fade>
          <Fade className="vabout__visual">
            <img src={gtcImg} alt="Équipe Global Sourcing Solution Group" />
          </Fade>
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section className="vcontact" id="contact-section">
        <div className="vin">
          <Fade className="vhead">
            <p className="vhead__eye vhead__eye--light">{t('home.contact.eye')}</p>
            <h2 className="vhead__h2 vhead__h2--light">{t('home.contact.h2')}</h2>
          </Fade>
          <div className="vcontact__body">
            <Fade className="vcontact__info">
              <div className="vcontact__btns">
                <a href="https://wa.me/33755201386" target="_blank" rel="noopener noreferrer" className="vcontact__btn vcontact__btn--whatsapp">
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.124.558 4.122 1.533 5.855L.057 23.57a.75.75 0 0 0 .92.92l5.716-1.476A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75a9.699 9.699 0 0 1-4.94-1.349l-.355-.21-3.676.949.968-3.591-.23-.368A9.699 9.699 0 0 1 2.25 12C2.25 6.615 6.615 2.25 12 2.25S21.75 6.615 21.75 12 17.385 21.75 12 21.75z"/></svg>
                  WhatsApp
                </a>
                <a href="mailto:noreply@globalsourcingsolutiongroup.com" className="vcontact__btn vcontact__btn--email">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><polyline points="2,4 12,13 22,4"/></svg>
                  Email
                </a>
                <a href="tel:+33755201386" className="vcontact__btn vcontact__btn--phone">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.02z"/></svg>
                  {t('home.contact.phone')}
                </a>
                <a href="https://www.linkedin.com/company/" target="_blank" rel="noopener noreferrer" className="vcontact__btn vcontact__btn--linkedin">
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M4.98 3.5a2 2 0 1 1-.02 4 2 2 0 0 1 .02-4zM3 8.79h3.96V21H3zm6.74 0H14v1.67h.06c.56-1.06 1.92-2.17 3.95-2.17 4.23 0 5.01 2.57 5.01 5.91V21h-3.96v-6.05c0-1.44-.03-3.29-2.01-3.29-2.02 0-2.33 1.58-2.33 3.19V21H9.74z"/></svg>
                  LinkedIn
                </a>
              </div>
            </Fade>
            <Fade>
              {sent ? (
                <div className="vcontact__thanks">
                  <span aria-hidden="true" style={{ fontSize: '3rem' }}>✅</span>
                  <h3>{t('home.contact.thanks.title')}</h3>
                  <p>{t('home.contact.thanks.desc')}</p>
                  <button className="vbtn vbtn--gold" onClick={() => setSent(false)}>{t('home.contact.thanks.new')}</button>
                </div>
              ) : (
                <form className="vcontact__form" onSubmit={(e) => { e.preventDefault(); setSent(true); }}>
                  <div className="vcontact__form-row">
                    <label>
                      <span>{t('home.contact.form.name')}</span>
                      <input type="text" placeholder={t('home.contact.form.name.ph')} required />
                    </label>
                    <label>
                      <span>{t('home.contact.form.email')}</span>
                      <input type="email" placeholder={t('home.contact.form.email.ph')} required />
                    </label>
                  </div>
                  <label>
                    <span>{t('home.contact.form.subject')}</span>
                    <input type="text" placeholder={t('home.contact.form.subject.ph')} required />
                  </label>
                  <label>
                    <span>{t('home.contact.form.message')}</span>
                    <textarea placeholder={t('home.contact.form.message.ph')} rows={5} required />
                  </label>
                  <button type="submit" className="vbtn vbtn--gold vbtn--full">
                    {t('home.contact.form.submit')}
                  </button>
                </form>
              )}
            </Fade>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;
